import "core-js/modules/es.array.push.js";
import { getPaymentList } from '@/api/global';
import { ensureAuth } from '@/utils/wxauth';
export default {
  data() {
    return {
      showTop: false,
      showCalendar: false,
      goods: {},
      active: 1,
      minDate: new Date(2010, 0, 1),
      maxDate: '',
      form: {
        oppAccountName: '',
        accountName: '',
        startDate: '',
        endDate: '',
        rangeDate: ''
      },
      collectionlist: [],
      page: 0,
      loading: false,
      finished: false,
      finishedtext: '没有更多了'
    };
  },
  created() {
    this.loadgetdate();
    // 授权由 ensureAuth 统一处理：地址栏有 code 就换成会话票据，
    // 没有票据则自动跳授权。不再把一次性的 code 存下来反复使用。
    ensureAuth();
  },
  methods: {
    showPopup() {
      this.showTop = true;
    },
    onConfirm(date) {
      const [start, end] = date;
      this.form.startDate = this.formatDate(start);
      this.form.endDate = this.formatDate(end);
      this.form.rangeDate = this.formatDate(start) + '/' + this.formatDate(end);
      this.showCalendar = false;
    },
    formatDate(date) {
      const dd = new Date(date);
      const y = dd.getFullYear();
      let m = dd.getMonth() + 1;
      let d = dd.getDate();
      m = m < 10 ? '0' + m : m;
      d = d < 10 ? '0' + d : d;
      return y + '-' + m + '-' + d;
    },
    loadgetdate() {
      this.maxDate = new Date(this.getDay(0));
      this.form.startDate = this.getDay(0);
      this.form.endDate = this.getDay(0);
    },
    godetail(id) {
      this.$router.push({
        path: '/detail',
        query: {
          id: id
        }
      });
    },
    totabbar() {
      if (this.active === 0) {
        this.$router.push({
          path: '/collection'
        });
      } else {
        this.$router.push({
          path: '/payment'
        });
      }
    },
    onSubmit() {
      this.showTop = false;
      this.page = 1;
      ensureAuth().then(auth => {
        if (!auth.ok) {
          this.finishedtext = auth.message;
          this.finished = true;
          return;
        }
        getPaymentList({
          startDate: this.form.startDate,
          endDate: this.form.endDate,
          accountName: this.form.accountName,
          oppAccountName: this.form.oppAccountName,
          page: 1,
          per: 10
        }).then(res => {
          if (res.data.status === 'success') {
            this.collectionlist = res.data.data;
          } else {
            console.log(res.data.message);
          }
        }).catch(err => {
          console.log('失获取数据败', err);
        });
      });
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        const _this = this;
        ensureAuth().then(auth => {
          if (!auth.ok) {
            _this.finishedtext = auth.message;
            _this.loading = false;
            _this.finished = true;
            return;
          }
          _this.page++;
          getPaymentList({
            startDate: _this.form.startDate,
            endDate: _this.form.endDate,
            accountName: _this.form.accountName,
            oppAccountName: _this.form.oppAccountName,
            page: _this.page,
            per: 10
          }).then(res => {
            if (res.data.status === 'success') {
              if (res.data.page_total >= _this.page) {
                res.data.data.forEach(function (item, index) {
                  _this.collectionlist.push(item);
                });
                _this.loading = false;
              } else {
                _this.finished = true;
              }
            } else {
              _this.finishedtext = res.data.message;
              _this.loading = false;
              _this.finished = true;
            }
          }).catch(err => {
            console.log('保存失败', err);
          });
        });
      }, 1000);
    },
    // 获取当前时间，day为number，getDay(-1):昨天的日期;getDay(0):今天的日期;getDay(1):明天的日期;【以此类推】
    getDay(day) {
      const today = new Date();
      const targetdaymilliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetdaymilliseconds);
      const tYear = today.getFullYear();
      let tMonth = today.getMonth();
      let tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + '-' + tMonth + '-' + tDate;
    },
    doHandleMonth(month) {
      let m = month;
      if (month.toString().length === 1) {
        m = '0' + month;
      }
      return m;
    }
  }
};